import React from 'react';
import Select from 'antd/lib/select';

const Option = Select.Option;

const TagSort = ({ label, list, onChange, filterId, value}) => {

  return (
    <div className="col-md-12">
      <Select
        showSearch
        style={{ width: '100%' }}
        placeholder={label}
        optionFilterProp={filterId}
        mode="tags"
        value = {value}
        onChange={onChange}
      >
        {list.map((item,index) => <Option key={`${filterId}Opts_${index}`} value={item}>{item}</Option>)}
      </Select>
    </div>
  );
}

export default TagSort